<template>
  <layout-content>
    <outgoing-call-recording />
  </layout-content>
</template>

<script>
  import OutgoingCallRecording from '@pbx/components/settings/outgoing-call-recording';
  export default {
    components: { OutgoingCallRecording }
  };
</script>
